'use client';

import type { IconName } from '@/components/entities/Sprite/Icon';
import { Icon } from '@/components/entities/Sprite/Icon';
import { cn } from '@/utils/cn';

interface NavigationItemContentProps {
  label: string;
  icon: IconName;
  variant: 'primary' | 'account';
  isActive?: boolean;
  badge?: string;
}

const NavigationItemContent = ({
  label,
  icon,
  variant,
  isActive,
  badge,
}: NavigationItemContentProps) => (
  <>
    <Icon
      name={icon}
      className={cn(
        'size-6 shrink-0 relative',
        variant === 'primary'
          ? 'text-white group-hover:text-c100'
          : 'text-c100 group-hover:text-c100',
        isActive && 'text-white',
      )}
    />
    <span
      className={cn(
        'relative',
        'group-hover:text-c100',
        isActive && 'text-white',
      )}
    >
      {label}
    </span>
    {badge && (
      <span className="relative ml-auto mr-2 shrink-0 rounded-full bg-primary-1! px-1.5 py-0.5 text-white! paragraph-xs-medium">
        {badge}
      </span>
    )}
  </>
);

export default NavigationItemContent;
